<template>
  <div class="content-parent-result">
    <div class="content-parent-result__title-wrapper">
      <div
        :to="
          $buildContentLink(parentTypeToMatchRoutes, {
            ...parent,
            id: parent.objectID,
          })
        "
        class="content-parent-result__link"
      >
        <div>
          <img
            :src="getParentInstructorPicture"
            class="content-parent-result__instructors-img"
            :alt="contentInstructors"
          />
        </div>
        <div class="content-parent-result__info-wrapper">
          <div>
            <span class="content-parent-result__title">
              {{ parent.name || '' }}
            </span>
            <span class="content-parent-result__title-mobile">
              {{ truncateTitle(parent.name, 50) || '' }}
            </span>
          </div>
          <div class="content-parent-result__bottom-info">
            <div class="content-parent-result__instructors">
              <span> with {{ getParentInstructorNames }} </span>
            </div>
            <div class="content-parent-result__learning-areas-wrapper">
              <div
                class="content-parent-result__circle"
                :style="
                  `background: ${getLAreaColor(parent.learning_areas[0])}`
                "
              ></div>
              <span>{{ parent.learning_areas[0].name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-parent-result__right-section">
        <router-link
          :to="
            $buildContentLink(parentTypeToMatchRoutes, {
              ...parent,
              id: parent.objectID,
            })
          "
          class="content-parent-result__see-details"
        >
          <span>See details</span>
        </router-link>
        <Active
          v-if="parentType === 'course'"
          :course="parent"
          class="content-parent-result__activator"
          :buttonStyle="'black'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Active from '@/components/properties/Active.vue'
import CONSTANTS from '@/constants'
import { bootcampCommons } from '@/helpers/mixins'
import { truncateText } from '@/helpers'

export default {
  name: 'ContentParent',
  components: {
    Active,
  },
  mixins: [bootcampCommons],
  props: {
    parent: {
      type: Object,
      required: true,
    },
    parentType: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      parents: CONSTANTS.SEARCH.PARENTS,
    }
  },
  computed: {
    getParentInstructorNames() {
      const amountOfInstructors = this.parent.instructors.length
      const firstInstructor = this.parent.instructors[0].name
      if (amountOfInstructors > 1) {
        return `${firstInstructor} + ${amountOfInstructors - 1}`
      }
      return firstInstructor
    },
    getParentInstructorPicture() {
      return this.parent.instructors[0].profile_img_url
        ? this.parent.instructors[0].profile_img_url
        : require('@/assets/images/instructor_fallback.png')
    },
    parentTypeToMatchRoutes() {
      return this.parentType === 'learning_path' ? 'path' : this.parentType
    },
  },
  methods: {
    getLAreaColor(larea) {
      return CONSTANTS.LEARNING_AREAS.COLORS[larea.id]
    },
    truncateTitle(value, length = null) {
      return truncateText(value, !length ? this.maxLength.value : length)
    },
  },
}
</script>

<style lang="scss" scoped>
.content-parent-result {
  @include mobile {
    display: flex;
    flex-direction: column;
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    padding: 5px 0;
  }
  &__right-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    @include mobile {
      flex-direction: row;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
    }
  }
  &__info-wrapper {
    margin-left: 10px;
  }
  &__link {
    display: flex;
    align-items: center;
    margin-top: 20px;
    @include mobile {
      margin-top: auto;
      width: 100%;
    }
  }
  &__see-details {
    margin: 20px 0;
    @include mobile {
      margin: 0 20px 0 0;
    }
    span {
      color: var(--white);
      font-family: var(--font-book);
      font-size: rem(14px);
      @include mobile {
        font-size: rem(16px);
        font-family: var(--font-bold);
      }
    }
  }
  &__title {
    display: none;
    color: var(--white);
    font-size: rem(18px);
    font-family: var(--font-bold);
    @include mobile {
      display: inherit;
    }
    &-mobile {
      display: inherit;
      color: var(--white);
      font-size: rem(18px);
      font-family: var(--font-bold);
      @include mobile {
        display: none;
      }
    }
  }
  &__title-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    @include mobile {
      flex-direction: row;
    }
  }
  &__activator {
    width: 100%;
    margin-bottom: 20px;
    @include mobile {
      width: auto;
      margin-left: 30px;
      margin-bottom: auto;
    }
  }
  &__bottom-info {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
  }
  &__instructors {
    color: var(--white);
    text-transform: capitalize;
    font-size: rem(14px);
    display: flex;
    align-items: center;
  }
  &__instructors-img {
    height: 50px;
    width: 50px;
    border-radius: 50%;
  }
  &__learning-areas-wrapper {
    display: flex;
    align-items: center;
    span {
      color: var(--white);
      font-size: rem(14px);
    }
    &:before {
      content: '';
      display: block;
      background: var(--perfect-gray);
      width: 1px;
      height: 20px;
      margin: 0 10px;
    }
  }
  &__circle {
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>
